import { render, staticRenderFns } from "./FolderFilesPreviewComponent.vue?vue&type=template&id=1239b2f0&"
import script from "./FolderFilesPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./FolderFilesPreviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./FolderFilesPreviewComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports